import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { Card, CheckBox, Typography, useCheckBox } from '@chilecompra/react-kit/components'
import { REACT_APP_BASE_URL } from '../../config/settings/environment'
import { FINES_PENALTIES_FILE } from '../../config/settings/constants'
import {
  DownloadBreach,
  Grid,
  IconArrowDownward,
  WrapperDownloadBreach,
  WrapperLabelCheck
} from './QuoteStepTwo.styles'

/**
 * The fines and penalties's component.
 */
const FinesPenalties = props => {
  const { finesPenalties, onSaveFinesPenalties } = props
  const filePath = `${REACT_APP_BASE_URL}/${FINES_PENALTIES_FILE}`
  const { authInfo } = useSelector(state => state.authorizationProvider)

  const {
    value: checked,
    onChange: handleChange,
    setValue: setFinesPenaltiesValue
  } = useCheckBox({
    changeCallback: updatedValue => onSaveFinesPenalties(updatedValue)
  })

  useEffect(() => {
    setFinesPenaltiesValue(finesPenalties)
  }, [finesPenalties])

  return (
    <Grid container>
      <Grid item xs={12} md={8}>
        <Card color="blank" enableBorder>
          <Grid container margin="12px">
            <Grid item xs={12} sm={12} md={1}>
              <CheckBox disabled={authInfo.hasObserverRole} checked={checked} onChange={handleChange} />
            </Grid>
            <Grid item xs={12} sm={12} md={11} padding="0 64px 0 0">
              <WrapperLabelCheck>
                <Typography color="black1" fontSize="18px" fontWeight="bold" lineHeight="22px" variant="h4">
                  Agregar cláusulas en caso de multas o incumplimientos (opcional)
                </Typography>
                <Typography color="black1" fontSize="14px" lineHeight="18px" variant="body2">
                  En caso de incumplimientos por parte de los proveedores, estas son las cláusulas que podrás aplicar en
                  tu Compra Ágil.
                </Typography>
                <Typography color="black1" fontSize="14px" lineHeight="18px" margin="8px 0 0" variant="body2">
                  En el documento adjunto podras ver el detalle de las multas y sanciones por incumplimientos de parte
                  de los proveedores.
                </Typography>
                <Typography color="black1" fontSize="14px" lineHeight="18px" variant="body2">
                  Esta información es parte de esta Compra Ágil y también será visible para los proveedores.
                </Typography>
                <WrapperDownloadBreach>
                  <IconArrowDownward fontSize="small" />
                  <DownloadBreach href={filePath} download>
                    Medidas derivadas de incumplimientos
                  </DownloadBreach>
                </WrapperDownloadBreach>
              </WrapperLabelCheck>
            </Grid>
          </Grid>
        </Card>
      </Grid>
    </Grid>
  )
}

FinesPenalties.propTypes = {
  finesPenalties: PropTypes.bool.isRequired,
  onSaveFinesPenalties: PropTypes.func.isRequired
}

export default FinesPenalties
